import { Component } from "react";
import { logWarn } from "@/lib/log";

// Any unexpected render error shows a recovery screen instead of a blank page.
export class ErrorBoundary extends Component {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error) {
    logWarn("Screen crashed", error);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div className="min-h-[100dvh] flex items-center justify-center px-6 text-center" data-testid="app-error-screen">
        <div className="max-w-sm">
          <p className="font-display text-2xl font-semibold">Something went wrong</p>
          <p className="text-sm text-neutral-400 mt-2">This screen hit a problem. Your chats and account are safe.</p>
          <div className="mt-6 flex justify-center gap-3">
            <button onClick={() => window.location.reload()} data-testid="app-error-reload-btn"
              className="px-4 py-2 rounded-full bg-sky-400 text-white text-sm font-medium hover:bg-sky-500 transition-colors">Reload</button>
            <button onClick={() => { window.location.href = "/app"; }} data-testid="app-error-home-btn"
              className="px-4 py-2 rounded-full border border-white/15 text-sm hover:bg-white/5 transition-colors">Go to my chats</button>
          </div>
        </div>
      </div>
    );
  }
}
